import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import s from './Achievements.scss';

interface IAchievementProps {
    text: string[];
    boldKeys: number[];
}

function Achievement({ text, boldKeys }: IAchievementProps) {
	useStyles(s);
	return (
		<div className="sl-teams-achievement">
			<div className="sl-teams-achievement__icon">
				<img
					src="https://blob.sololearn.com/web-assets/teams-achievement.png"
					alt="teams-achievement"
				/>
			</div>
			<div className="sl-teams-achievement__text">
				{text.map((segment, index) => (
					<span
						key={index}
						className={
							boldKeys.includes(index)
								? 'sl-teams-achievement__text__bold'
								: ''
						}
					>
						{segment}
					</span>
				))}
			</div>
		</div>
	);
}

const achievementsData: readonly IAchievementProps[] = Object.freeze([
	{
		text: ['Forbes ', 'America’s Best Startup Employers 2021'],
		boldKeys: [0],
	},
	{
		text: ['2021 ', 'EdTech Breakthrough ', 'Award'],
		boldKeys: [1],
	},
	{
		text: ['2023’s most promising ', 'North America EdTech 200'],
		boldKeys: [1],
	},
	{
		text: ['Facebook ', 'FbStart’s Global App of the Year 2017'],
		boldKeys: [0],
	},
	{
		text: ['2021 Tech & Learning Award of ', 'Excellence'],
		boldKeys: [1],
	},
	{
		text: ['Women We Admire: The ', 'Top 100 Women CEOs ', 'of 2021 '],
		boldKeys: [1],
	},
]);

export function Achievements() {
	return (
		<div className="sl-teams-achievements">
			{achievementsData.map(({ text, boldKeys }, index) => (
				<Achievement key={index} text={text} boldKeys={boldKeys} />
			))}
		</div>
	);
}
